type Props = {};
export default function Main({}: Props) {
  return <div>Admin App</div>;
}
